import React from 'react';
import { Modal, Box, CircularProgress } from '@mui/material';

const LoaderSpinnerComponent = ({ open }) => {
  return (
    <Modal
      open={open}
      aria-labelledby="loading-modal"
      aria-describedby="shows-loading-spinner"
      disableAutoFocus
      disableEnforceFocus
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress size={50} color="primary" />
      </Box>
    </Modal>
  );
};

export default LoaderSpinnerComponent;
